import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import { BodyMediumText } from '@prisjakt/ui/text/variants';

export const InfoPagesList = styled.ul`
  list-style: none;
  margin: 0;
`;

export const ListItem = styled.li`
  margin-bottom: ${layout.measurements.spacing050};
`;

export const Link = styled(BodyMediumText)`
  && {
    color: ${p => p.theme.footer.fg.primary};

    &:hover {
      color: ${p => p.theme.buttons.link.textHover};
      text-decoration: underline;
    }
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;
